<template>
  <div class="container" v-if="is_visible">
    <div class="overlay" @click="closeModal"></div>
    <div class="prato-container">
      <span class="tit" v-text="' '+$t('dish_details')+' '+cardData?.dataCatalog?.tabela?.[dateIndex]?.data"></span>
      <div class="prato" v-if="coluna.id_prato">
        <div class="plateDetails">
          <div class="plate">
            <span
              v-for="(tit,titkey) in gridDetail"
              :key="titkey"
              :title="getPlateData(tit, coluna?.id_prato)"
              v-text="getPlateData(tit, coluna?.id_prato)"
            ></span>
            <label v-if="exchangePlate == false" class="percConsumo" for="percConsumo">
              {{$t('percentage_of_consumption')}}:
            <input
              class="input-number"
              name="percConsumo"
              type="number"
              step="0.15"
              v-if="!coluna?.isFrozenDay"
              :disabled="copyDiners"
              v-model="formattedPercentual"
              @input="markInputChanged"
              @focus="saveOldValue"
            />
              <span
                v-if="coluna?.isFrozenDay"
                :title="coluna.perc_consumo"
                v-text="coluna.perc_consumo"
              />
            </label>
          </div>
          <div class="frequencias" v-if="getFrequencyInfo(coluna?.id_prato) != ''" v-html="getFrequencyInfo(coluna?.id_prato)"></div>
        </div>
      </div>
      
      <div class="plate-exchage" v-if="exchangePlate && copyDiners !== true">
        <div class="filter-input">
          <input
            type="text"
            v-model="filterText"
            @input="applyFilter"
            placeholder="Digite para filtrar pratos"
          />
        </div>
        <div class="sub-container">
          <div
            class="plate"
            v-for="(plate, key) in filteredPlates"
            :key="key"
            @click="loadDetail(plate)"
            :class="{'active': chossPlate?.id_prato === plate.id_prato}"
          >
            <span v-for="(tit,titkey) in gridTit" :key="titkey" v-text="plate[tit]"></span>
            <span v-if="hasValidations(plate)" class="validation-alert">!</span>
          </div>
        </div>
        <div class="plateDetails" v-if="chossPlate">
          <div class="plate">
            <span
              v-for="(tit,titkey) in gridDetail"
              :key="titkey"
              :title="getPlateData(tit, chossPlate.id_prato)"
              v-text="getPlateData(tit, chossPlate.id_prato)"
            ></span>
          </div>
          <div class="frequencias" v-if="frequenciasPrato != ''" v-html="frequenciasPrato"></div>
        </div>
      </div>
      
      <div class="copy-diners" v-if="copyDiners">
        <div class="sub-container copy-diners-content">

          <header class="sub-container-header">
            <h4 v-text="''+$t('copy_by')+':'"/>
            
            <div class="radio-btn">
              <input type="radio" id="percent" value="percent" v-model="pickedRadioChoice"/>
              <label for="percent" class="labelForRadio" v-text="$t('consumption_percentage')" />
            </div>

            <div class="radio-btn">
              <input type="radio" id="number" value="number" v-model="pickedRadioChoice"/>
              <label for="number" class="labelForRadio" v-text="$t('number_of_diners')" />
            </div>

            <input
              class="input-number"
              name="cpyConsumo"
              type="number"
              :step="pickedRadioChoice === 'percent' ? 0.15 : 1"
              v-model="copyValue"
            />
          </header>

          <section class="sub-container-content">
              <h4 v-text="$t('exceptions')"/>
              <div class="exceptions">
                <div v-for="day in daysOfWeek" :key="day.key" class="exception-item">
                  <label :for="day.key" class="weekDay">{{ day.name }}</label>
                  <input
                    class="input-number"
                    type="number"
                    :id="day.key"
                    :step="pickedRadioChoice === 'percent' ? 0.15 : 1"
                    v-model="exceptions[day.key]"
                  />
                </div>
              </div>
            </section>
        </div>
      </div>

      <div class="button-container">
        <button
            v-if="currentPlateValidations.length > 0 && this.exchangePlate"
            class="hasprato"
            @click="showPlateValidations"
          >
            <i class="fas fa-exclamation-circle"></i> {{ $t('ver_validacoes') }}
        </button>
        <button v-text="''+$t('cancel')+''" class="hasprato" @click="clearPlate"></button>
        
        <button
          v-text="''+$t('delete_plate')+''"
          class="hasprato"
          v-if="coluna?.id_prato != null && !coluna?.isFrozenDay && copyDiners !== true"
          @click="deletePlate"
        ></button>

        <button
          v-text="''+$t('change_plate')+''"
          class="hasprato"
          v-if="exchangePlate == false && otherOptions.length > 0 && copyDiners !== true"
          @click="exchangePlate = true"
        ></button>

        <button
          v-text="''+$t('copy_diners')+''"
          class="hasprato"
          v-if="coluna?.id_prato && copyDiners !== true"
          @click="handleCopyDiners(coluna)"
        ></button>

        <button
          v-text="''+$t('apply')+''"
          v-if="!copyDiners"
          :disabled="!isApplyEnabled"
          :class="{'hasprato': isApplyEnabled}"
          @click="editarprato"
        ></button>

        <button
          v-text="''+$t('apply')+''"
          v-if="copyDiners"
          :class="{'hasprato': isCopyDinnersAble()}"
          @click="handleApplyCopyDiners"
        ></button>
      </div>

    </div>
    <FeedbackConfirmationModal
      :categoria="applyFeedback.categoria"
      :motivo="applyFeedback.motivo"
      :showError="showConfirmationError"
      @updateCategoria="applyFeedback.categoria = $event"
      @updateMotivo="applyFeedback.motivo = $event"
      @confirm="handleConfirmationConfirm"
      @cancel="handleConfirmationCancel"
      @showError="showConfirmationError = true"
      @clearError="showConfirmationError = false"
    />
    <PlateValidationModal :validations="currentPlateValidations" />
  </div>

</template>

<script>
/*global localStorage*/
import PlateSubsController from "../controllers/PlateSubsController";
import { t } from 'i18next';
import moment from 'moment';
import FeedbackConfirmationModal from "./modals/FeedbackConfirmationModal";
import PlateValidationModal from "./modals/PlateValidationModal";

export default {
  name: "PlatesSubstitution",
  components: {
    FeedbackConfirmationModal,
    PlateValidationModal
  },
  data() {
    return {
      cardData: {},
      coluna: {},
      dateIndex: null,
      is_visible: false,
      languageLocale: null,
      applyFeedback: { categoria: "", motivo: "" },
      showConfirmationError: false,
      exceptions: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
        holiday: null
      },
      copyDiners: false,
      pickedRadioChoice: 'percent',
      copyValue: null,
      inputChanged: false,
      exchangePlate: false,
      gridTit: ["nm_grupo", "id_prato", "nm_prato"],
      gridDetail: [
        "nm_grupo",
        "nm_prato",
        "id_prato",
        "vlr_prato",
        "id_pre_preparo",
        "utilizacao_prato",
        "nm_atratividade",
        "nm_tipocorte",
        "nm_modopreparo",
        "nm_ingrediente_1",
        "nm_ingrediente_2",
        "nm_proteina",
      ],
      frequenciasPrato: "",
      filterText: "",
      filteredPlates: [],
      otherOptions: [],
      chossPlate: null,
      label: {
        nm_grupo: t('group_'),
        nm_prato: t('plate') + ": ",
        id_prato: t('cod'),
        vlr_prato: t('unit_cost') + t('R$'),
        id_pre_preparo: t('pre_preparation'),
        utilizacao_prato: t('use_'),
        nm_atratividade: t('attractiveness_'),
        nm_tipocorte: t('type_of_cut') + ": ",
        nm_modopreparo: t('method_of_preparation') + ": ",
        nm_ingrediente_1: t('ing_main_1') + ": ",
        nm_ingrediente_2: t('ing_main_2') + ": ",
        nm_proteina: t('type_protein') + ": "
      },
      validationMap: new Map(),
      currentPlateValidations: [],
      old_perc_consumo: null
    };
  },
  mounted() {
    this.languageLocale = localStorage.getItem('lang') || 'pt-BR';
  },
  watch: {
    pickedRadioChoice() {
      if(this.coluna && this.cardData.dataCatalog){
        const percentual = this.coluna.perc_consumo.toFixed(2);
        const qt_comensais = this.cardData.dataCatalog?.tabela?.[this.dateIndex]?.qt_comensais ?? 0;
        const comensais = Math.round(percentual * qt_comensais / 100);
      
        this.copyValue = this.pickedRadioChoice === 'percent' ? percentual : comensais;
        this.resetDaysOfTheWeek();
      }
    }
  },
  computed: {
    daysOfWeek() {
      const currentLocale = moment.locale(this.languageLocale);
      const baseDays = [
        { key: 'monday', name: moment.weekdays(1) },
        { key: 'tuesday', name: moment.weekdays(2) },
        { key: 'wednesday', name: moment.weekdays(3) },
        { key: 'thursday', name: moment.weekdays(4) },
        { key: 'friday', name: moment.weekdays(5) },
        { key: 'saturday', name: moment.weekdays(6) },
        { key: 'sunday', name: moment.weekdays(0) },
        { key: 'holiday', name: t('holidays') }
      ];
    
      // Ajusta nomes para o português, se necessário
      return baseDays.map(day => {
        let translatedName = day.name;
        
        if(translatedName !== t('holidays')){
          if (currentLocale === 'pt-br') {
            translatedName = translatedName.replace('-feira', '') + 's';
          } else {
            translatedName += 's';
          }
        }

        return { key: day.key, name: translatedName };
      });
    },

    formattedPercentual: {
      get() {
        // Retorna o valor formatado para duas casas decimais
        return parseFloat(this.coluna?.perc_consumo).toFixed(2);
      },
      set(newValue) {
        // Converte o novo valor para número e atualiza o plate
        this.coluna.perc_consumo = parseFloat(newValue);
      }
    },
    
    isApplyEnabled() {
      return ((this.exchangePlate === true && !!this.chossPlate) || (this.inputChanged && (this.exchangePlate === false && this.coluna?.id_prato != null && this.coluna?.perc_consumo > 0))
      );
    }
  },
  
  methods: {

    saveOldValue() {
      this.old_perc_consumo = this.coluna.perc_consumo;
    },
    open(coluna, dateIndex, cardData) {
      this.cardData = cardData;
      this.coluna = coluna;
      this.dateIndex = dateIndex;
      this.is_visible = true;
      this.otherOptions = this.loadOtherOptions();
      this.filteredPlates = this.otherOptions;
      this.generateValidationMap();
    },
    loadOtherOptions() {
      const list_plates = this.coluna?.pratos_disponiveis || [];
      const pratos = this.cardData?.dataCatalog?.pratos;
      const grupos = this.cardData?.dataCatalog?.grupos;

      if (!list_plates.length || !pratos || !grupos) return [];

      return list_plates
        .map(id => {
          const prato = pratos[id];
          if (!prato) return null;

          const grupo = grupos[prato.id_grupo];
          if (!grupo) return null;

          return {
            id_grupo: grupo.id_grupo,
            nm_grupo: grupo.nm_grupo,
            id_prato: prato.id_prato,
            nm_prato: prato.nm_prato
          };
        })
        .filter(Boolean);
    },
    generateValidationMap() {
      const map = new Map();
      if(this.otherOptions?.length){
        for (const option of this.otherOptions){
          const validations = PlateSubsController.getPlateValidations(option, this.coluna, this.dateIndex, this.cardData.dataCatalog);
          map.set(option.id_prato, validations ?? []);
        }
      }
      this.validationMap = map;
    },    

    hasValidations(plate) {
      if (!plate?.id_prato) return false;
      const validations = this.validationMap.get(plate.id_prato);
      return Array.isArray(validations) && validations.length > 0;
    },

    showPlateValidations() {
      this.$modal.show("plateValidationModal");
    },

    markInputChanged() {
      this.inputChanged = true;
    },
  
  
    resetDaysOfTheWeek() {
      this.exceptions = {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null,
        holiday: null
      };
    },

    handleApplyCopyDiners() {
      const dataCatalog = this.cardData?.dataCatalog;
      const coluna = this.coluna;
      if(!dataCatalog || !coluna ) return;

      Object.keys(this.exceptions).forEach(day => {
        if (this.exceptions[day] === null) {
          this.exceptions[day] = this.copyValue;
        }
      });

      PlateSubsController.updateCopiaComenais(dataCatalog, coluna, this.exceptions, this.pickedRadioChoice);

      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
      this.closeModal();
    },
    handleCopyDiners(coluna) {
      this.copyDiners = true;
      this.copyValue = coluna.perc_consumo.toFixed(2);
    },
    
    isCopyDinnersAble() {
      return this.pickedRadioChoice !== null && this.copyValue > 0;
    },
    
    applyFilter() {
      const text = this.filterText.toLowerCase();
      if (!text) {
        this.filteredPlates = this.otherOptions;
        return;
      }
    
      this.filteredPlates = this.otherOptions.filter((plate) => {
        const { nm_grupo, nm_prato, id_prato } = plate;
    
        // "Contém" (texto entre % %)
        if (text.startsWith('%') && text.endsWith('%')) {
          const searchTerm = text.slice(1, -1);
          return (
            nm_grupo.toLowerCase().includes(searchTerm) ||
            nm_prato.toLowerCase().includes(searchTerm) ||
            id_prato.toLowerCase().includes(searchTerm)
          );
        }
    
        // "Termina com" (texto começa com %)
        if (text.startsWith('%')) {
          const searchTerm = text.slice(1);
          return (
            nm_grupo.toLowerCase().endsWith(searchTerm) ||
            nm_prato.toLowerCase().endsWith(searchTerm) ||
            id_prato.toLowerCase().endsWith(searchTerm)
          );
        }
    
        // "Inicia com" (padrão ou texto não começa com %)
        return (
          nm_grupo.toLowerCase().startsWith(text) ||
          nm_prato.toLowerCase().startsWith(text) ||
          id_prato.toLowerCase().startsWith(text)
        );
      });
    },

    getFrequencyInfo: function (id_prato) {
      if(!id_prato) return "";
      const nr_semana = this.cardData?.dataCatalog?.tabela?.[this.dateIndex]?.nr_semana;
      const pratoInfo = this.cardData?.dataCatalog?.pratos?.[id_prato];
      const grupoInfo = this.cardData?.dataCatalog?.grupos?.[pratoInfo?.id_grupo];
      const freq_grupos = this.cardData?.dataCatalog?.freq_grupos?.[pratoInfo.id_grupo];
      const freq_pratos = this.cardData?.dataCatalog?.freq_pratos?.[id_prato];
      if(!freq_grupos && !freq_pratos) return;
      let text = "Frequencia:"
      if(freq_pratos){
        text += `<br>${this.$t('plate_used', { PARAM: `${pratoInfo.qt_utilizado}` })},  ${this.$t('this_week',{PARAM: `${pratoInfo.qt_utilizado_sem?.[nr_semana]||0}`})} 
                 <br>${this.$t('min_month', { PARAM: `${freq_pratos.qt_min_mes}` })}, ${this.$t('max_month', { PARAM: `${freq_pratos.qt_max_mes}` })}, ${this.$t('max_week', { PARAM: `${freq_pratos.qt_max_sem}` })}`;
      }
      if(freq_grupos){
        text += `<br>${this.$t('group_used', { PARAM: `${grupoInfo.qt_utilizado}` })},  ${this.$t('this_week',{PARAM: `${grupoInfo.qt_utilizado_sem?.[nr_semana]||0}`})} 
        <br>${this.$t('min_month', { PARAM: `${freq_grupos.qt_min_mes}` })}, ${this.$t('max_month', { PARAM: `${freq_grupos.qt_max_mes}` })}, ${this.$t('max_week', { PARAM: `${freq_grupos.qt_max_sem}` })}`;
      }
      return text;
    },

    loadDetail: function (plate) {
      if (!plate?.id_prato) return;
      this.chossPlate = plate;
      this.frequenciasPrato = this.getFrequencyInfo(this.chossPlate.id_prato);
      this.currentPlateValidations = this.validationMap?.get(this.chossPlate.id_prato) ?? [];
    },
    getPlateData(tit, id_prato) {
      if (!id_prato) return "";

      const dataCatalog = this.cardData?.dataCatalog;
      if (!dataCatalog) return "";
      const dia = dataCatalog?.tabela?.[this.dateIndex];
      if(!dia) return "";
      const pratos = dataCatalog.pratos;
      const prato = pratos?.[id_prato];
      if (!prato) return "";
      
      let utilizacao_prato = null;
      if (this.coluna?.id_prato === id_prato) {
        utilizacao_prato =
          this.coluna?.utilizacao_prato ??
          PlateSubsController.getPlateUtilization(
            dia.data,
            prato.id_grupo,
            dia.id_feriado,
            dataCatalog?.utilizacao_grupo
          );
      }

      // resolvers dinâmicos (executa só o necessário)
      const resolvers = {
        nm_grupo: () =>
          dataCatalog.grupos?.[prato.id_grupo]?.nm_grupo,

        nm_prato: () => prato.nm_prato,

        id_prato: () => prato.id_prato,

        vlr_prato: () => prato.vlr_prato,

        id_pre_preparo: () => (prato.id_pre_preparo ? "S" : "N"),

        utilizacao_prato: () => utilizacao_prato,

        nm_atratividade: () =>
          dataCatalog.atratividade?.[prato.id_atratividade]?.nm_atratividade,

        nm_tipocorte: () =>
          dataCatalog.tipocorte?.[prato.id_tipocorte]?.nm_tipocorte,

        nm_modopreparo: () =>
          dataCatalog.modopreparo?.[prato.id_modopreparo]?.nm_modopreparo,

        nm_ingrediente_1: () =>
          dataCatalog.ingredientes?.[prato.id_ingrediente_1]?.nm_ingrediente,

        nm_ingrediente_2: () =>
          dataCatalog.ingredientes?.[prato.id_ingrediente_2]?.nm_ingrediente,

        nm_proteina: () =>
          dataCatalog.proteinas?.[prato.id_proteina]?.nm_proteina ?? "NA",
      };

      let val = resolvers[tit]?.();

      // mantém sua regra especial
      if (tit === "vlr_prato" && val != null) {
        val = parseFloat(val).toFixed(5);
      }

      return (this.label[tit] || "") + (val ?? "");
    },
    trocarPrato: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_coluna || !this.chossPlate) return;
      
      PlateSubsController.changeCatalogPlate(dataCatalog, this.dateIndex, id_coluna, id_prato, this.chossPlate.id_prato);
      
      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
    },
    closeModal: function () {
      this.resetDaysOfTheWeek();
      this.chossPlate = null;
      this.exchangePlate = false;
      this.inputChanged = false;
      this.copyDiners = false;
      this.pickedRadioChoice = 'percent';
      this.frequenciasPrato = "";
      this.is_visible = false;
    },
    clearPlate: function () {
      if(this.copyDiners){
        this.copyDiners = false;
        this.inputChanged = false;
        this.pickedRadioChoice = 'percent';
        this.resetDaysOfTheWeek();
        return;
      }
      
      if(this.exchangePlate){
        this.exchangePlate = false;
        return;
      }
      this.currentPlateValidations = [];
      this.closeModal();
    },
    editPlate: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_prato || !id_coluna ) return;
      
      PlateSubsController.updateCatalogConsumption(dataCatalog, this.dateIndex, id_coluna, this.old_perc_consumo);

      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
    },
    editarprato: function () {
      this.showConfirmationModal();
    },
    deletePlate: function () {
      const dataCatalog = this.cardData?.dataCatalog;
      const id_prato = this.coluna?.id_prato;
      const id_coluna = this.coluna?.id_coluna;
      if(!dataCatalog || !id_prato || !id_coluna) return;
      
      PlateSubsController.changeCatalogPlate(dataCatalog, this.dateIndex, id_coluna, id_prato, null);
      
      const tabelaAtual = dataCatalog?.tabela;
      const temTabela = Array.isArray(tabelaAtual) && tabelaAtual.length > 0;
      if (temTabela) {
        dataCatalog.Eventos = [];
        dataCatalog.Eventos = PlateSubsController.generateScenarioEvents(tabelaAtual, this.applyFeedback.categoria, this.applyFeedback.motivo);
      }      
      this.$emit("updateCenarioFromPlateSub", this.cardData);
      this.clearPlate();
      this.closeModal();
    },

    showConfirmationModal: function () {
      this.applyFeedback.categoria = "";
      this.applyFeedback.motivo = "";
      this.showConfirmationError = false;
      this.$modal.show("feedbackConfirmationModal");
    },

    handleConfirmationConfirm: function () {
      if (this.exchangePlate) {
        this.trocarPrato();
      } else if (this.coluna?.id_prato != null) {
        this.editPlate();
      }
      this.closeModal();
      this.$modal.hide("feedbackConfirmationModal");
    },

    handleConfirmationCancel: function () {
      this.$modal.hide("feedbackConfirmationModal");
    },
  },
};
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");
.overlay {
  position: fixed;
  z-index: 10;
  .full;
  background: rgba(0, 0, 0, 0.5);
}
.ovflw {
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}

.frequencias {
  position: relative;
  display: block;
  background: lightgray;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 0 10px 10px;
}

.button-container {
  display: table;
  margin: auto 0 auto auto;
  button {
    font-weight: 500;
    font-size: 1.1rem;
    -webkit-box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24),
      0 0 2px rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24), 0 0 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 0;
    color: white;
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
    background: #dc143d;
    font-size: 0.9rem;
    padding: 6px 13px;
    margin: -15px 15px 10px 0;
    cursor: not-allowed;
    opacity: 0.5;
    &:last-of-type {
      margin-right: 0;
    }
    &:hover.hasprato {
      background: #212146;
    }
    &.hasprato {
      opacity: 1;
      cursor: pointer;
    }
  }
}

.labelForRadio{
  font-size: 0.9rem;
}

.prato-container {
  min-width: max-content;
  z-index: 11;
  padding: 0 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background: white;
  width: 50%;
  .tit {
    display: block;
    padding: 15px 0;
  }
  
  .copy-diners-content{
   min-height: fit-content; 
  }
  .sub-container {
    border-radius: 5px;
    position: relative;
    display: block;
    margin: 0 0 15px 0;
    max-height: 90px;
    -webkit-box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 100px -20px, rgba(0, 0, 0, 0.3) 0px 0px 60px -30px, rgba(10, 37, 64, 0.35) 0px 0px 6px 0px inset;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 0px 100px -20px, rgba(0, 0, 0, 0.3) 0px 0px 60px -30px, rgba(10, 37, 64, 0.35) 0px 0px 6px 0px inset;

    overflow-x: hidden;
    overflow-y: scroll;
    padding: 10px 0;

    .plate {
      position: relative;
      overflow: hidden;
      border: solid 1px transparent;
      padding: 0 10px;
      display: grid;
      grid-template-columns: 25% 20% 55%;
      cursor: pointer;
      &:hover,
      &.active {
        border: solid 1px red;
      }
      span {
        .ovflw;
      }
      &:nth-of-type(2n) {
        background: rgba(196, 196, 196, 0.2);
      }
    }
    .validation-alert {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      color: #e63946;
      font-weight: bold;
      font-size: 18px;
      white-space: nowrap;
      pointer-events: none;
    }
  }
  
  .sub-container-header{
    display: flex;
    align-items: end;
    gap: 5px;
    padding-left: 10px;
    
    h4{
      margin: 0;
    }
  }
  
  .radio-btn{
    display: flex;
  }
  
  .input-number {
    width: 5rem;
    text-align: center;
    border: 1px solid black;
    border-radius: 4px;
  }
  
  .sub-container-content{
    padding-left: 10px;
    
    h4{
      /*font-weight: 400;*/
      margin: 10px 0 10px 0;
    }

    .exceptions {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      /*max-width: 600px;*/
      padding-inline: 30px;
    }
    
    .exception-item {
      display: flex;
      gap: 5px;
      align-items: center;
    }
    
    .weekDay {
      width: 5rem;
      text-transform: capitalize;
      font-size: 0.9rem;
    }

  }
  
  .plateDetails {
    padding-bottom: 15px;
    .plate {
      display: grid;
      grid-template-columns: 50% 50%;
      background: lightgray;
      padding: 5px 0;
      border-radius: 5px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    span {
      padding: 0 10px;
      display: block;
      .ovflw;
    }
  }
}
.percConsumo {
  padding: 0 10px;
  input, span {
    /*max-width: 50px !important;*/
    display: inline-block !important;
    vertical-align: middle;
  }
}
.filter-input {
  margin-bottom: 15px;

  input {
    width: 96%;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    color: #333;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      outline: none;
      border-color: #007bff;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
    }
  }
}

</style>